import { AsyncSearch } from './actionTypes';
import { DateUtils, doRequest } from '../../utils';

const TIMEOUT_MS = 5000;

const getRoomsFormatted = (rooms) =>
    rooms.map((room) => ({
        numAdults: room.adults,
        childrenAges: room.kids,
    }));

const requestingAsyncSearch = () => ({
    type: AsyncSearch.REQUEST_ASYNC_SEARCH,
});

const receiveAsyncSearch = (searchValue) => ({
    type: AsyncSearch.RECEIVE_ASYNC_SEARCH,
    searchValue,
});

const errorAsyncSearch = (error) => ({
    type: AsyncSearch.ERROR_ASYNC_SEARCH,
    error: {
        reason: 'The async search request timed out or failed',
        message: error?.message,
    },
});

const formatAsyncSearch = ({ id }) => {
    return { id };
};

const getSearchURL = () => {
    return '/frontend-home/service/accommodation-search-async/v1/search';
};

const getSearchBody = ({ segments, rooms }) => {
    if (!segments || segments.length < 2 || !rooms) {
        return '';
    }
    const { type, id } = segments[0].destination;
    const checkIn = DateUtils.toString(segments[0].date);
    const checkOut = DateUtils.toString(segments[1].date);
    return {
        'buyPath': 7202, // HSA_HOME
        'searchType': 'STANDALONE',
        'membershipFee': false,
        'geoAccommodation': {
            'geoId': id,
            'geoType': type
        },
        'checkInDate': checkIn,
        'checkOutDate': checkOut,
        'roomRequests': getRoomsFormatted(rooms || []),
        'maxResults': 10,
        'maxSize': 10,
        'upsell': false
    };
};

const fetchAsyncSearch = (currentSearch) => {
    const url = getSearchURL();
    const body = getSearchBody(currentSearch);
    return (dispatch) => {
        dispatch(requestingAsyncSearch());
        const requestPromise = doRequest(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
            body: JSON.stringify(body),
        })
            .then((response) => response.json())
            .then((data) => formatAsyncSearch(data));
        const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Async search request timed out after 10s')), TIMEOUT_MS)
        );
        return Promise.race([requestPromise, timeoutPromise])
            .then((searchValue) => {
                dispatch(receiveAsyncSearch(searchValue));
            })
            .catch((error) => {
                dispatch(errorAsyncSearch(error));
            });
    };
};

const shouldFetchAsyncSearch = ({ isFetching }) => {
    return !isFetching;
};

export const getAsyncSearch = (currentSearch) => {
    return (dispatch, getState) => {
        const state = getState();
        if (shouldFetchAsyncSearch(state)) {
            return dispatch(fetchAsyncSearch(currentSearch));
        } else {
            return Promise.resolve();
        }
    };
};
